import React from 'react';

interface SRPlaceholderTabProps {
  sectionTitle: string;
  message: string;
  testId: string;
}

const SRPlaceholderTab: React.FC<SRPlaceholderTabProps> = ({
  sectionTitle,
  message,
  testId,
}) => (
  <div
    className="border border-[#DCDDE0] rounded-[8px] p-5 flex flex-col gap-4 flex-1"
    data-testid={`${testId}-card`}
  >
    <p className="text-titleDefault font-medium text-on-surface-variant">
      {sectionTitle}
    </p>
    <p
      className="text-bodyMedium px-[20px] py-[14px] text-on-surface-variant text-center"
      data-testid={testId}
    >
      {message}
    </p>
  </div>
);

export default SRPlaceholderTab;
